import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Navigate } from 'react-router-dom';
import { Users, FileText, Settings, Shield, Mail, BarChart3 } from 'lucide-react';
import UserManagement from './UserManagement';
import EmailSettings from './EmailSettings';
import FileManager from './FileManager';
import PermissionsManager from './PermissionsManager';
import SystemSettings from './SystemSettings';
import Reports from './Reports';

const AdminPanel = () => {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('users');

  // Redirect if not admin
  if (!user || user.role !== 'admin') {
    return <Navigate to="/dashboard" replace />;
  }

  const tabs = [
    {
      id: 'users',
      label: 'Felhasználók',
      icon: Users,
      component: UserManagement
    },
    {
      id: 'email',
      label: 'E-mail Értesítések',
      icon: Mail,
      component: EmailSettings
    },
    {
      id: 'files',
      label: 'Fájlok',
      icon: FileText,
      component: FileManager
    },
    {
      id: 'permissions',
      label: 'Jogosultságok',
      icon: Shield,
      component: PermissionsManager
    },
    {
      id: 'reports',
      label: 'Riportok',
      icon: BarChart3,
      component: Reports
    },
    {
      id: 'settings',
      label: 'Beállítások',
      icon: Settings,
      component: SystemSettings
    }
  ];

  const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component || UserManagement;

  return (
    <div className="max-w-7xl mx-auto">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Adminisztrációs Panel</h1>
        <p className="text-gray-600">Rendszer és felhasználó kezelés</p>
      </div>

      {/* Tab Navigation */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 mb-6">
        <div className="border-b border-gray-200">
          <nav className="flex space-x-8 px-6" aria-label="Tabs">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`${
                    activeTab === tab.id
                      ? 'border-primary-500 text-primary-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition-colors`}
                >
                  <Icon className="h-5 w-5" />
                  <span>{tab.label}</span>
                </button>
              );
            })}
          </nav>
        </div>

        {/* Tab Content */}
        <div className="p-0">
          <ActiveComponent />
        </div>
      </div>
    </div>
  );
};

export default AdminPanel; 